import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"   viewBox="0 0 994.000000 994.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,994.000000) scale(0.100000,-0.100000)">

<path d="M6465 8581 c-233 -37 -427 -87 -525 -136 -14 -7 -59 -27 -100 -46
-41 -18 -84 -41 -95 -52 -17 -15 -17 -17 -2 -11 9 3 17 11 17 17 0 6 2 8 5 5
12 -12 -10 -40 -51 -64 -24 -14 -44 -28 -44 -31 0 -2 5 -1 12 3 6 4 8 3 4 -4
-3 -6 -23 -16 -44 -22 -20 -7 -47 -19 -59 -26 -13 -8 -23 -10 -23 -4 0 16 -26
12 -51 -10 l-24 -19 23 4 c12 2 27 7 34 11 12 7 5 -9 -16 -35 -6 -7 -11 -19
-12 -25 -3 -24 -17 -56 -25 -56 -4 0 -33 -22 -65 -50 -31 -27 -61 -47 -66 -44
-6 4 -8 -15 -4 -50 7 -73 -8 -74 -84 -3 -86 79 -140 120 -148 112 -4 -4 -1
-10 6 -12 7 -3 24 -16 37 -29 13 -13 29 -24 35 -24 5 0 10 -4 10 -10 0 -5 -4
-10 -10 -10 -5 0 -10 -5 -10 -11 0 -6 7 -8 15 -5 11 4 33 -12 64 -44 27 -28
46 -50 44 -50 -3 0 -1 -6 5 -12 14 -18 19 -67 7 -66 -28 2 -58 24 -137 101
-66 64 -88 93 -90 114 -1 15 -2 39 -3 53 -1 14 -6 34 -12 45 -6 11 -16 60 -22
109 -7 50 -15 94 -18 99 -10 16 20 67 51 86 17 11 42 30 56 43 14 13 51 42 83
66 31 23 57 45 57 49 0 7 -362 -4 -600 -17 -139 -9 -883 -46 -1280 -65 -63 -3
-205 -10 -315 -15 -297 -15 -378 -19 -630 -30 -126 -6 -269 -15 -316 -21 -279
-34 -522 -237 -588 -493 -20 -75 -21 -115 -26 -715 -3 -350 -7 -779 -10 -954
l-5 -318 123 2 c68 1 129 -1 136 -5 7 -5 9 -16 5 -29 -4 -12 -8 -264 -8 -559
-1 -295 -4 -539 -7 -542 -3 -3 -59 -9 -125 -12 -105 -6 -121 -9 -136 -28 l-18
-21 0 29 c0 31 -118 271 -187 381 -24 39 -62 107 -84 152 -22 45 -43 84 -47
87 -4 2 -7 -139 -7 -314 l0 -317 27 -12 c16 -7 28 -19 28 -27 0 -17 -26 -19
-36 -3 -7 12 -170 6 -182 -6 -3 -2 15 -24 40 -47 50 -48 113 -139 137 -202 18
-46 64 -121 81 -131 7 -4 19 -19 28 -34 9 -15 30 -42 45 -61 l28 -33 25 24
c14 13 35 39 47 59 11 19 25 38 30 41 5 4 13 91 18 195 6 103 12 190 15 193 8
8 2 -814 -12 -1604 -7 -412 -11 -790 -8 -840 5 -74 12 -103 40 -161 42 -90
125 -170 227 -218 107 -51 162 -60 325 -58 218 3 426 31 682 92 172 41 265 77
324 127 22 18 43 33 48 33 4 0 8 10 8 21 0 19 -4 21 -35 16 -33 -5 -36 -4 -54
36 -11 23 -15 44 -10 45 5 2 9 9 9 16 0 34 79 162 80 130 0 -5 6 -1 14 8 15
20 58 38 92 38 25 0 84 -48 84 -69 0 -30 16 -15 137 133 9 11 36 46 61 79 136
178 378 334 614 395 91 23 121 26 263 25 214 -1 321 -26 551 -127 27 -12 87
-50 164 -103 28 -19 142 -113 178 -145 12 -11 20 -23 17 -26 -3 -3 -18 6 -33
20 -61 57 -240 182 -315 219 -204 103 -334 134 -567 134 -162 0 -181 -2 -260
-27 -138 -44 -255 -97 -361 -164 -69 -43 -230 -202 -278 -272 -13 -20 -27 -39
-30 -42 -3 -3 -10 -13 -16 -22 -5 -9 -27 -41 -48 -72 -42 -62 -41 -67 13 -113
51 -43 82 -41 130 8 22 23 40 46 40 51 0 6 7 8 14 5 10 -4 13 -1 9 9 -4 12 -1
13 19 3 28 -12 50 -66 41 -99 -3 -12 2 -28 10 -38 10 -11 14 -27 11 -40 -5
-17 -1 -24 18 -31 13 -5 30 -16 37 -25 16 -19 51 -21 51 -3 0 18 29 44 55 49
11 2 19 9 18 15 -1 6 17 19 40 28 23 9 60 29 82 44 60 42 185 106 230 118 22
6 67 18 100 26 33 9 80 23 105 32 99 37 379 46 597 20 68 -8 130 -12 138 -9 8
4 17 -1 21 -10 10 -27 73 -50 127 -48 28 1 56 -3 64 -9 11 -9 12 -9 7 4 -3 10
2 20 16 27 12 6 19 14 16 17 -3 4 -15 -2 -26 -12 -31 -28 -52 -13 -44 32 8 48
13 52 28 30 7 -9 18 -17 23 -17 6 0 16 -6 22 -14 19 -23 181 -130 231 -153 25
-11 88 -39 140 -63 52 -23 103 -46 112 -51 33 -17 255 -68 348 -80 72 -9 122
-9 205 -1 224 23 388 82 595 217 204 132 237 152 280 173 62 29 215 82 240 82
11 0 20 4 20 8 0 4 35 16 78 26 42 9 85 19 95 22 9 3 17 1 17 -4 0 -5 -25 -14
-55 -21 -30 -7 -57 -17 -60 -22 -4 -5 -14 -9 -24 -9 -26 0 -71 -23 -71 -37 0
-11 -75 -28 -95 -21 -6 2 -29 -16 -51 -40 -23 -23 -48 -42 -56 -42 -8 0 -23
-9 -33 -20 -10 -11 -26 -20 -35 -20 -20 0 -53 -33 -43 -43 13 -13 -27 -44 -51
-40 -18 4 -26 0 -31 -16 -3 -12 -9 -21 -13 -21 -4 0 -20 -23 -37 -50 -17 -29
-37 -50 -47 -50 -10 0 -18 -4 -18 -9 0 -5 -16 -12 -35 -15 -24 -5 -49 -21 -77
-52 -22 -24 -47 -44 -54 -44 -7 0 -21 -11 -30 -25 -9 -14 -23 -25 -30 -25 -8
0 -14 -4 -14 -9 0 -5 -15 -12 -32 -15 -18 -4 -51 -20 -72 -36 -22 -17 -51 -30
-65 -30 -14 0 -35 -7 -45 -15 -10 -8 -23 -12 -28 -9 -5 3 -15 0 -23 -6 -8 -7
-24 -10 -35 -7 -28 7 -25 0 14 -37 18 -18 35 -38 37 -44 5 -15 171 -16 229 -2
25 7 64 9 87 6 24 -3 43 -1 45 5 2 5 34 16 72 24 83 18 158 45 168 61 4 6 22
17 40 25 18 7 47 23 63 35 17 13 52 29 79 36 26 7 59 23 73 36 35 32 100 72
117 72 9 0 24 9 34 20 20 22 121 45 155 36 11 -3 42 6 68 20 27 13 55 24 64
24 9 0 26 6 38 14 12 8 45 17 72 21 85 11 128 27 168 62 20 18 44 33 53 33 21
0 70 28 108 63 17 15 34 27 39 27 8 0 28 18 108 95 63 62 78 81 93 128 9 26
16 53 16 59 0 6 9 20 20 32 26 28 83 93 116 134 26 32 64 135 64 173 0 17 15
49 52 108 14 23 70 63 85 60 22 -5 133 51 133 67 0 7 7 15 16 18 10 4 13 13 9
27 -5 14 -3 19 3 15 18 -11 32 90 36 244 2 90 10 173 20 220 20 87 16 171 -14
298 -11 46 -20 116 -20 155 -1 40 -8 90 -16 112 -31 79 -30 151 1 139 8 -4 27
2 43 12 15 10 30 18 34 17 15 -5 28 67 28 158 0 91 -13 154 -30 144 -7 -4 -61
114 -75 162 -3 12 -18 32 -32 43 -23 18 -26 28 -24 65 1 24 -5 60 -14 81 -8
20 -15 43 -15 51 0 8 -9 26 -20 40 -11 14 -20 34 -20 44 0 11 -4 19 -10 19
-18 0 -10 -39 22 -111 29 -66 30 -72 15 -84 -9 -7 -63 -14 -120 -17 -104 -6
-147 -18 -147 -41 0 -17 -44 -106 -52 -107 -9 0 -14 153 -9 274 l3 78 -30 -7
c-18 -3 -33 -2 -37 4 -3 6 -17 11 -31 11 -14 0 -23 -4 -20 -9 6 -9 -73 -21
-146 -21 -27 0 -48 5 -48 10 0 6 -6 10 -14 10 -15 0 -20 -12 -31 -70 -20 -116
-26 -130 -62 -146 -25 -12 -31 -19 -21 -25 7 -5 -25 -9 -77 -9 -62 0 -85 3
-75 10 13 8 12 10 -3 10 -37 0 -65 -23 -99 -84 -25 -44 -23 -31 27 159 48 182
121 473 161 645 13 58 29 115 34 128 7 15 7 30 0 43 -8 15 -7 19 4 19 10 0 25
32 47 103 45 147 51 157 98 157 21 0 66 3 99 6 l61 7 7 46 c4 25 10 48 14 51
7 5 35 145 50 250 6 36 14 89 20 118 5 28 14 76 19 105 4 28 8 235 7 458 -1
363 -3 409 -18 425 -9 11 -23 37 -32 59 -10 22 -25 49 -35 60 -10 11 -22 31
-26 45 -10 31 -44 84 -82 127 l-28 32 -1 -287 c0 -311 -10 -395 -69 -597 -30
-105 -92 -279 -111 -315 -7 -14 -29 -60 -48 -103 -19 -42 -72 -137 -117 -209
-45 -73 -87 -148 -95 -168 -12 -34 -13 -34 -13 -7 -1 32 22 80 89 188 57 90
97 168 157 304 98 222 138 360 168 575 39 283 3 849 -60 955 -35 59 -149 165
-178 165 -3 0 -7 -12 -10 -28 -4 -17 -37 -58 -89 -108 -120 -117 -143 -147
-158 -201 -20 -75 -26 -82 -41 -50 -9 21 -17 26 -33 21 -16 -4 -18 -3 -7 5 12
8 13 16 4 45 -7 23 -7 36 -1 36 5 0 6 10 3 23 -7 23 -36 51 -70 68 -11 5 -40
23 -65 39 -25 16 -70 42 -100 58 -30 16 -78 40 -106 55 -84 44 -220 87 -389
123 -139 30 -183 35 -330 39 -93 2 -192 0 -220 -4z m-1687 -158 c-38 -3 -48
-8 -48 -22 0 -10 -9 -26 -20 -36 -23 -21 -26 -37 -5 -29 18 7 53 -25 38 -34
-6 -4 -13 -16 -16 -27 -4 -18 -5 -18 -6 3 -1 19 -5 21 -28 16 -15 -4 -33 -7
-40 -7 -7 0 -13 -6 -13 -13 0 -15 -95 -28 -153 -20 -23 3 -34 3 -24 0 9 -3 17
-10 17 -15 0 -5 66 -9 153 -9 137 0 156 -2 171 -19 15 -16 17 -71 26 -492 5
-261 10 -634 12 -830 3 -331 2 -358 -15 -377 -10 -11 -17 -26 -15 -33 2 -10
-8 -15 -32 -16 -34 -1 -34 -1 -5 6 22 5 26 8 14 13 -16 6 -70 5 -430 -7 -132
-5 -158 -3 -169 10 -9 11 -15 156 -21 607 -5 326 -11 598 -13 603 -2 6 -10 -5
-17 -22 -8 -18 -19 -33 -25 -33 -7 0 -15 -6 -17 -12 -4 -10 -8 -10 -15 1 -7 9
-12 10 -16 2 -4 -6 -2 -11 3 -11 6 0 11 -8 11 -17 0 -13 -3 -14 -12 -5 -7 7
-20 12 -30 12 -11 0 -15 5 -12 14 3 7 -1 16 -9 19 -8 3 -25 26 -38 52 -13 26
-26 48 -30 51 -3 2 -4 -281 -2 -629 2 -347 0 -637 -4 -644 -9 -13 -84 -17
-441 -28 -102 -3 -171 -1 -183 5 -18 10 -19 24 -19 218 0 233 -10 416 -20 387
-6 -17 -8 -16 -14 10 -4 17 -31 57 -61 90 -30 33 -55 65 -55 71 0 6 -7 17 -15
24 -8 7 -15 20 -15 30 0 10 -7 23 -15 30 -13 11 -15 -36 -15 -416 0 -236 -3
-438 -6 -450 -6 -24 -43 -27 -425 -40 -162 -6 -197 -5 -205 7 -5 8 -9 46 -10
84 -1 167 -7 328 -11 307 -2 -12 -9 -19 -15 -16 -6 4 -14 1 -18 -6 -6 -9 -12
-9 -31 0 -35 18 -70 52 -80 78 -11 29 -27 28 -35 -2 -3 -13 -4 -125 -2 -249
l3 -225 -180 -6 c-99 -4 -231 -11 -293 -17 -63 -6 -119 -8 -125 -6 -9 3 -13
-34 -14 -137 -5 -250 -20 -270 -24 -31 -6 451 2 1651 12 1705 22 112 134 264
247 334 135 84 174 93 467 106 204 9 347 16 820 40 173 9 692 33 1050 49 170
8 653 11 563 4z m2162 -57 c104 -21 282 -78 370 -119 65 -31 286 -172 328
-210 12 -11 22 -25 22 -31 0 -6 -26 -35 -57 -66 -96 -91 -161 -165 -164 -185
-3 -13 -14 -21 -32 -23 -23 -3 -26 -6 -17 -22 8 -15 6 -28 -9 -55 -16 -31 -20
-33 -32 -19 -7 9 -12 31 -10 49 1 18 -3 36 -8 40 -6 3 -9 11 -5 17 6 10 -43
68 -58 68 -5 0 -30 15 -56 33 -71 50 -197 106 -287 128 -150 37 -426 36 -580
-3 -116 -29 -354 -134 -412 -183 -10 -8 -53 -39 -95 -70 -71 -51 -77 -59 -83
-98 -3 -23 -4 -62 -3 -86 2 -24 -1 -45 -7 -47 -5 -2 -32 17 -60 42 -27 25 -80
71 -118 101 -37 31 -69 65 -71 77 -3 11 -7 62 -10 112 l-5 91 37 35 c74 69
242 198 258 198 3 0 24 13 47 28 114 76 383 174 557 202 41 6 82 13 90 15 44
11 393 -4 470 -19z m-80 -592 c123 -30 260 -100 328 -166 29 -28 52 -55 52
-60 0 -5 -35 -47 -77 -92 -154 -163 -163 -175 -163 -216 0 -21 -3 -45 -6 -54
-8 -22 -34 -20 -35 2 -3 95 -6 106 -38 133 -18 15 -61 41 -97 59 -54 28 -77
33 -157 38 -94 5 -232 -12 -243 -29 -3 -5 -26 -19 -50 -31 -25 -11 -75 -43
-112 -69 l-66 -49 -2 -62 c-2 -85 -2 -88 -16 -88 -10 0 -136 108 -204 175 -29
29 -31 36 -37 134 -8 118 -10 113 73 175 133 99 210 139 355 186 168 54 317
58 495 14z m-1318 -169 c0 -5 -5 -11 -11 -13 -6 -2 -11 4 -11 13 0 9 5 15 11
13 6 -2 11 -8 11 -13z m1822 9 c9 -3 16 -13 16 -21 0 -10 -6 -13 -16 -9 -9 3
-18 6 -20 6 -2 0 -4 7 -4 15 0 17 2 18 24 9z m-1789 -33 c-3 -6 3 -14 12 -20
11 -6 13 -11 5 -11 -10 0 -10 -4 2 -16 20 -20 21 -45 1 -38 -8 4 -15 10 -15
15 0 4 -6 6 -14 3 -9 -3 -19 4 -26 16 -8 15 -8 20 -1 16 6 -4 11 -2 11 3 0 6
-4 11 -10 11 -5 0 -10 4 -10 10 0 5 7 7 15 4 8 -4 15 -1 15 5 0 6 5 11 11 11
5 0 8 -4 4 -9z m-1442 -68 c8 -43 -7 -47 -26 -8 -16 33 -16 35 2 35 12 0 20
-9 24 -27z m1517 -54 c0 -6 -4 -7 -10 -4 -5 3 -10 11 -10 16 0 6 5 7 10 4 6
-3 10 -11 10 -16z m330 -283 c0 -26 -6 -18 -14 19 -5 22 -4 26 4 15 5 -8 10
-24 10 -34z m788 -9 c75 -48 110 -91 128 -158 11 -43 11 -67 3 -114 -6 -33
-14 -64 -17 -70 -4 -5 -7 -12 -7 -15 -5 -33 -53 -106 -87 -130 -57 -42 -102
-53 -196 -49 -45 2 -82 1 -82 -3 0 -5 8 -8 18 -8 9 -1 3 -7 -16 -15 -22 -10
-32 -20 -30 -32 2 -13 -2 -17 -16 -15 -17 3 -18 2 -7 -12 28 -34 -17 -16 -72
28 -76 62 -80 76 -75 263 3 158 3 158 36 216 60 103 152 149 292 144 72 -3 91
-7 128 -30z m1175 -1019 c-3 -16 -9 -28 -14 -28 -5 0 -8 -35 -8 -77 0 -82 -3
-104 -27 -194 -7 -31 -14 -71 -14 -88 0 -17 -4 -50 -10 -73 -5 -24 -17 -88
-26 -143 -9 -55 -21 -122 -26 -150 -5 -27 -13 -88 -18 -135 -6 -47 -12 -96
-15 -110 -2 -14 -8 -49 -13 -79 -10 -57 -30 -81 -66 -81 -16 0 -18 -2 -7 -9
26 -17 -10 -23 -116 -20 -118 4 -115 6 -128 -75 -3 -21 -8 -36 -10 -34 -2 2
-13 62 -24 133 -11 72 -29 175 -40 230 -22 106 -66 343 -77 410 -12 73 -21 69
-33 -16 -14 -94 -22 -141 -46 -279 -10 -52 -21 -117 -25 -145 -4 -27 -8 -43
-9 -35 -4 27 -31 -74 -31 -116 0 -34 -4 -43 -26 -53 -15 -6 -24 -14 -21 -18 4
-3 13 0 22 7 9 7 15 8 15 2 0 -19 -62 -32 -151 -32 -94 0 -97 -2 -109 -54 -5
-19 -9 -25 -12 -16 -11 31 -40 146 -47 185 -8 39 -43 168 -103 375 -17 58 -43
152 -58 210 -16 58 -41 148 -55 200 -28 97 -35 223 -15 261 8 13 32 17 137 22
74 3 133 1 139 -4 7 -5 14 -22 17 -37 3 -15 11 -49 17 -77 6 -27 13 -68 15
-90 3 -22 16 -85 30 -140 13 -55 34 -170 46 -255 24 -178 37 -224 39 -140 3
135 90 721 112 747 8 10 41 13 136 11 l125 -3 13 -60 c8 -33 22 -105 33 -160
18 -90 35 -164 62 -280 16 -63 30 -134 42 -209 7 -38 18 -71 25 -74 9 -3 12
25 12 120 0 180 18 533 31 605 10 57 22 80 42 82 4 1 63 1 132 1 111 0 125 2
125 17 0 11 3 13 9 8 5 -6 7 -22 4 -37z m-1676 -56 c15 -10 77 -144 97 -212 9
-29 19 -58 24 -64 10 -13 72 -171 72 -183 0 -4 25 -73 56 -153 30 -80 67 -176
81 -215 14 -38 35 -92 48 -120 12 -27 32 -81 45 -118 21 -66 21 -69 4 -82 -23
-17 -149 -30 -215 -22 l-49 6 -1 -52 c-1 -29 -1 -55 0 -59 0 -5 -3 -8 -8 -8
-5 0 -14 42 -21 93 -6 50 -19 128 -29 172 l-18 80 -39 -1 c-21 0 -99 -3 -171
-5 l-133 -4 -9 -50 c-6 -27 -13 -71 -17 -97 -3 -26 -12 -53 -20 -59 -8 -6 -14
-17 -14 -24 0 -9 -23 -15 -72 -19 -89 -7 -338 -16 -432 -16 l-68 0 4 -35 c2
-19 2 -35 -2 -35 -6 1 -50 91 -50 105 0 5 -22 57 -49 115 -26 58 -64 141 -83
185 l-35 80 -54 1 -55 0 0 -210 1 -211 -129 -5 -128 -5 -10 25 c-6 15 -12 251
-16 586 -5 545 -4 562 14 568 10 3 132 7 269 8 214 2 258 0 303 -14 104 -34
175 -97 219 -197 39 -87 37 -192 -6 -293 -33 -79 -59 -112 -120 -160 l-34 -26
35 -63 c20 -35 50 -93 68 -129 19 -36 51 -96 73 -134 22 -38 43 -80 46 -95 9
-31 34 -35 39 -6 2 11 19 74 38 140 19 66 44 153 55 193 11 40 25 92 33 115 7
23 22 74 34 112 142 473 172 566 184 582 13 16 223 29 245 15z m-1922 -129 c9
-32 21 -63 26 -69 5 -6 32 -78 60 -160 28 -82 66 -192 84 -244 19 -52 45 -128
59 -167 14 -40 36 -101 49 -135 14 -35 33 -94 44 -133 23 -81 52 -175 59 -190
2 -6 -46 -11 -131 -13 -93 -3 -135 -1 -135 7 0 6 -7 11 -15 11 -19 0 -29 21
-50 111 -10 42 -20 81 -24 86 -3 6 -42 7 -96 3 -49 -4 -123 -6 -163 -6 l-72 1
0 -32 c0 -38 -17 -127 -31 -164 -7 -18 -20 -29 -41 -33 -50 -10 -188 -7 -188
4 0 6 -16 8 -36 5 l-36 -4 7 42 c4 23 20 77 35 119 25 69 101 311 132 423 6
22 51 162 100 312 65 198 94 273 106 276 9 3 67 5 129 6 l112 1 16 -57z m3748
17 c16 -22 25 -40 20 -40 -4 0 -17 14 -28 30 -11 16 -23 30 -27 30 -5 0 -8 5
-8 10 0 20 15 9 43 -30z m-4665 -5 c79 -19 207 -77 215 -98 8 -21 -30 -87 -80
-141 -24 -25 -43 -52 -43 -60 0 -23 -13 -20 -45 10 -50 46 -91 57 -202 55 -40
-1 -58 -7 -82 -27 -33 -28 -38 -48 -19 -89 15 -33 102 -75 227 -110 147 -41
196 -74 258 -171 66 -103 68 -203 8 -327 -41 -85 -85 -129 -183 -184 -63 -35
-73 -38 -170 -41 -119 -5 -206 9 -277 43 -27 13 -66 30 -85 39 -19 9 -53 32
-75 51 -35 30 -38 36 -25 47 9 7 46 50 84 96 41 49 72 79 79 75 7 -3 32 -20
56 -36 90 -61 222 -84 291 -49 46 23 66 77 46 125 -18 44 -27 50 -141 88 -55
18 -137 52 -182 74 -46 23 -83 39 -83 36 0 -3 12 -24 25 -46 26 -42 32 -60 15
-50 -6 4 -22 30 -36 58 -15 29 -37 63 -50 77 -47 51 -69 118 -69 215 0 78 4
97 28 147 51 104 168 183 293 197 108 13 154 12 222 -4z m-963 -43 c14 -10 70
-131 70 -151 0 -9 7 -16 15 -16 21 0 39 -43 33 -79 -5 -32 90 -334 142 -452
13 -30 42 -119 64 -198 22 -78 52 -167 66 -197 31 -68 33 -89 5 -64 -17 16
-37 18 -154 16 -112 -2 -136 0 -150 14 -9 9 -16 24 -16 33 0 9 -11 50 -24 91
l-24 74 -128 -3 c-71 -2 -142 -4 -159 -4 -29 -1 -30 -3 -35 -53 -3 -29 -11
-58 -18 -65 -6 -6 -12 -27 -12 -44 0 -18 -5 -36 -10 -39 -8 -5 -7 -11 1 -21
10 -12 -2 -14 -80 -14 -54 0 -91 4 -91 10 0 6 -9 10 -20 10 -11 0 -20 -5 -20
-11 0 -8 -4 -8 -14 0 -8 7 -25 9 -40 5 -14 -3 -26 -3 -26 1 0 3 26 86 59 183
32 97 77 238 101 312 121 388 204 628 226 650 5 5 50 11 99 13 50 1 99 4 110
5 11 1 25 -2 30 -6z m-1215 -1272 c0 -5 -7 -7 -15 -4 -8 4 -15 8 -15 10 0 2 7
4 15 4 8 0 15 -4 15 -10z m6599 -75 c146 -35 232 -158 211 -303 -12 -85 -42
-145 -85 -168 -19 -10 -35 -22 -35 -25 0 -4 20 -15 45 -25 48 -18 109 -77 126
-122 6 -15 15 -53 21 -85 12 -70 -3 -161 -36 -210 -20 -30 -83 -72 -148 -98
-16 -6 -28 -17 -28 -24 0 -31 -152 -53 -402 -57 l-157 -3 -6 -32 c-3 -18 -10
-33 -15 -33 -5 0 -11 15 -14 33 -6 37 -21 755 -21 992 l0 160 70 6 c153 12
409 9 474 -6z m-680 -412 c1 -448 -1 -474 -50 -546 -41 -60 -134 -149 -184
-175 -47 -25 -58 -27 -175 -27 l-125 1 -72 38 c-39 20 -77 38 -85 40 -29 4
-45 24 -75 91 -58 127 -63 166 -73 580 -5 209 -6 383 -2 387 8 8 239 14 247 7
2 -3 7 -68 10 -145 4 -76 8 -155 10 -174 1 -19 6 -132 10 -250 8 -239 15 -267
75 -307 25 -18 47 -23 92 -23 53 0 62 3 96 34 l37 35 -4 416 c-3 347 -1 419
10 426 8 5 69 9 135 9 l121 0 2 -417z m-1172 367 c49 -11 194 -87 200 -105 1
-5 -24 -47 -57 -93 -33 -46 -60 -92 -60 -103 0 -19 -3 -18 -38 9 -40 32 -144
72 -187 72 -14 0 -46 -5 -71 -11 -56 -14 -72 -44 -54 -102 12 -42 42 -61 155
-97 177 -56 213 -72 277 -123 35 -28 79 -125 85 -190 5 -59 3 -69 -35 -149
-29 -62 -52 -95 -81 -119 -24 -19 -37 -35 -31 -39 19 -12 -62 -57 -130 -73
-117 -28 -256 -23 -345 11 -22 9 -66 33 -97 54 -31 21 -60 38 -64 38 -3 0 -4
-13 0 -30 3 -16 2 -30 -3 -30 -9 0 -41 89 -41 112 0 7 24 38 53 68 29 30 61
68 73 84 l21 29 59 -36 c83 -51 138 -69 219 -71 86 -1 119 16 129 68 8 44 -13
90 -52 110 -16 8 -64 24 -108 35 -138 36 -217 68 -241 95 -28 33 -35 33 -29 1
6 -31 -4 -32 -26 -1 -52 72 -71 283 -34 382 33 89 108 154 223 193 66 22 211
28 290 11z m-1277 -62 c13 -24 33 -72 45 -108 37 -106 102 -284 109 -300 3 -8
19 -53 34 -100 16 -47 41 -116 56 -155 64 -168 122 -362 112 -373 -3 -2 -20
-8 -38 -12 -28 -7 -29 -8 -8 -9 14 -1 32 -6 40 -11 23 -15 -209 -13 -239 3
-15 7 -28 26 -34 47 -4 19 -15 59 -24 88 -15 53 -16 54 -46 48 -34 -6 -249 -9
-281 -4 -17 3 -21 -7 -32 -75 -7 -43 -20 -87 -29 -97 -9 -9 -15 -24 -13 -31 2
-11 -20 -15 -107 -17 -133 -3 -132 9 3 18 l97 7 -101 1 c-79 2 -104 -1 -114
-13 -21 -26 -32 -17 -27 23 2 20 36 129 74 242 39 113 89 264 111 335 22 72
69 218 103 325 73 224 57 207 205 209 l82 1 22 -42z m-506 -5 c4 -9 6 -61 5
-114 l-1 -97 -42 -6 c-61 -8 -212 -10 -225 -2 -6 4 -11 1 -11 -6 0 -7 0 -209
0 -449 l0 -436 -62 -7 c-33 -3 -89 -6 -124 -6 -52 0 -65 3 -74 19 -6 13 -10
171 -10 445 l0 425 -52 -4 c-186 -15 -195 -14 -217 6 -18 17 -21 31 -21 114 0
64 4 96 13 102 6 4 154 13 327 19 489 17 487 17 494 -3z m-1076 -50 c29 -44
72 -141 99 -228 14 -44 34 -102 43 -130 10 -27 24 -70 30 -95 16 -58 42 -132
50 -145 4 -5 12 -23 18 -40 6 -16 22 -61 37 -100 25 -67 46 -136 66 -218 5
-21 20 -61 34 -89 14 -28 22 -54 19 -57 -3 -3 -9 1 -14 8 -6 11 -32 13 -131 7
-117 -6 -123 -6 -145 15 -13 13 -24 34 -25 48 0 14 -8 55 -18 91 l-17 65 -74
1 -75 1 65 -6 c42 -4 59 -9 47 -13 -22 -9 -255 -13 -264 -4 -4 3 10 6 30 6 20
0 39 4 42 10 7 11 -85 2 -98 -10 -4 -3 -14 -44 -23 -91 -9 -46 -21 -90 -28
-97 -6 -7 -39 -16 -71 -22 l-60 -9 67 4 c61 4 92 -5 70 -19 -5 -3 -62 -8 -128
-12 -110 -6 -120 -5 -136 13 -17 18 -16 23 13 104 16 46 57 165 89 264 32 99
76 234 98 300 22 66 54 167 72 225 17 58 42 134 55 170 l23 65 78 6 c149 10
141 11 162 -18z m-944 -47 c64 -19 174 -86 223 -136 82 -82 113 -183 113 -370
0 -101 -28 -233 -61 -286 -10 -17 -19 -38 -19 -47 0 -8 -13 -29 -29 -46 -15
-16 -26 -32 -24 -35 9 -9 -52 -68 -109 -106 -83 -55 -164 -71 -379 -73 -96 -1
-186 1 -201 6 l-28 7 1 493 c0 270 4 515 7 542 l7 50 75 6 c160 12 376 9 424
-5z m6685 -130 c1 -93 -5 -81 -12 24 -4 54 -3 78 3 65 5 -11 9 -51 9 -89z m-4
-168 c-22 -237 -74 -400 -174 -548 -24 -36 -47 -67 -50 -70 -17 -13 -71 -89
-71 -99 0 -7 -7 -14 -15 -18 -9 -3 -15 -14 -13 -26 2 -11 -5 -24 -17 -31 -26
-14 -45 -38 -41 -51 1 -5 -7 -15 -18 -20 -12 -6 -21 -20 -21 -30 0 -11 -7 -21
-15 -21 -8 -1 -21 -2 -28 -3 -8 0 -12 -6 -10 -13 3 -7 -8 -19 -23 -28 -33 -18
-139 -117 -139 -130 0 -5 -8 -11 -17 -14 -16 -6 -53 -33 -104 -79 -22 -20
-148 -95 -232 -140 -62 -33 -178 -73 -327 -114 -99 -28 -243 -88 -315 -133
-22 -14 -44 -27 -50 -29 -5 -2 -55 -34 -110 -71 -181 -120 -270 -164 -485
-237 -70 -24 -90 -26 -301 -29 -209 -4 -228 -2 -267 16 -22 11 -49 20 -59 20
-32 0 -359 124 -384 146 -8 8 -19 14 -24 14 -4 0 -28 15 -54 33 -25 17 -57 38
-71 45 -28 14 -117 92 -106 92 4 0 40 -22 79 -49 206 -139 408 -225 620 -263
185 -33 395 -31 541 7 185 47 296 101 524 254 99 67 277 157 363 184 30 9 125
37 212 62 161 47 279 104 427 208 69 48 203 179 233 226 12 20 89 110 171 201
82 91 156 176 164 190 9 14 27 38 40 54 13 17 29 41 34 55 56 141 118 372 118
437 0 42 7 74 17 74 3 0 2 -33 -2 -72z m-161 -766 c-16 -10 -36 -76 -28 -95 4
-13 1 -17 -14 -17 -24 0 -37 -16 -21 -25 7 -5 3 -12 -10 -22 -12 -8 -21 -19
-21 -25 0 -5 -9 -22 -20 -38 -11 -15 -17 -30 -13 -34 3 -3 -7 -19 -24 -35 -16
-15 -37 -38 -45 -50 -14 -19 -29 -27 -60 -30 -5 -1 -14 -15 -21 -32 -8 -21
-29 -40 -66 -60 -51 -26 -86 -30 -62 -6 16 16 13 27 -4 21 -8 -4 -15 -13 -15
-21 0 -22 -61 -73 -89 -73 -17 0 -22 -4 -17 -16 5 -14 4 -15 -9 -4 -14 11 -3
25 78 104 78 77 207 224 207 237 0 2 37 43 83 92 45 48 98 104 117 126 30 33
37 36 50 24 10 -9 12 -16 4 -21z m-594 -596 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1
-10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-75 -46 c-10 -11 -22 -17 -28 -13 -5
3 1 12 14 19 33 18 35 17 14 -6z m-45 -30 c0 -5 -8 -10 -17 -10 -15 0 -16 2
-3 10 19 12 20 12 20 0z m-60 -27 c-8 -3 -22 -11 -30 -17 -13 -10 -13 -9 -1 7
7 9 21 17 30 16 13 0 14 -1 1 -6z m-2622 -197 c2 -9 -1 -16 -7 -16 -6 0 -11 5
-11 11 0 7 -8 18 -17 25 -16 13 -15 13 7 5 14 -4 26 -16 28 -25z"/>
<path d="M5044 5785 c4 -19 7 -87 8 -151 l0 -117 94 5 c103 6 132 18 165 71
16 26 19 44 16 93 -8 111 -41 134 -195 134 l-94 0 6 -35z"/>
<path d="M6156 5740 c-3 -14 -15 -70 -26 -125 -12 -55 -28 -122 -36 -149 -8
-27 -14 -61 -14 -74 l0 -25 82 7 c45 4 84 9 86 11 3 2 -5 44 -16 92 -11 48
-28 126 -37 173 -20 100 -31 127 -39 90z"/>
<path d="M4195 5658 c-2 -7 -6 -26 -8 -43 -2 -16 -21 -93 -40 -170 -20 -77
-33 -143 -29 -146 4 -4 44 -4 90 -2 61 4 82 9 82 19 0 8 -8 47 -19 87 -10 39
-29 116 -41 170 -22 96 -27 108 -35 85z"/>
<path d="M2321 5518 c-7 -40 -17 -86 -22 -103 -5 -16 -18 -59 -28 -95 -11 -36
-22 -73 -26 -82 -6 -16 1 -17 92 -11 54 3 100 7 102 9 1 1 -8 38 -23 81 -14
43 -35 122 -46 176 -12 53 -25 97 -29 97 -4 0 -13 -33 -20 -72z"/>
<path d="M2039 4779 c-10 -6 -7 -9 14 -9 29 0 35 5 14 13 -8 3 -20 1 -28 -4z"/>
<path d="M7567 4278 c2 -68 7 -124 12 -126 5 -2 50 1 102 6 114 12 119 17 119
124 0 75 -1 79 -26 88 -14 6 -58 10 -99 10 -41 0 -77 5 -80 10 -3 6 -12 10
-19 10 -10 0 -12 -28 -9 -122z"/>
<path d="M7579 3965 c-8 -8 1 -268 10 -277 3 -3 60 0 126 8 146 17 155 24 154
118 0 83 -17 128 -51 140 -19 7 -34 6 -50 -3 -23 -11 -72 -7 -158 14 -14 4
-28 4 -31 0z"/>
<path d="M7828 3513 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7668 3503 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M6025 3469 l-40 -20 35 7 c19 3 42 12 50 20 20 19 3 16 -45 -7z"/>
<path d="M5915 3440 l-50 -7 47 -1 c26 -1 50 3 53 8 3 6 5 9 3 8 -2 0 -25 -4
-53 -8z"/>
<path d="M4585 4154 c-3 -16 -10 -42 -15 -59 -5 -16 -18 -69 -29 -117 -11 -48
-27 -103 -35 -123 l-15 -35 100 0 c111 0 107 -3 83 75 -8 28 -28 101 -44 164
-17 63 -32 116 -34 119 -3 2 -8 -9 -11 -24z"/>
<path d="M3010 4108 c0 -30 -48 -233 -71 -294 -10 -29 -15 -55 -12 -58 4 -3
49 -6 101 -6 93 0 94 0 89 23 -41 170 -93 357 -99 357 -4 0 -8 -10 -8 -22z"/>
<path d="M1957 4164 c-3 -4 -6 -131 -7 -283 0 -152 -3 -300 -7 -330 l-6 -54
82 5 c70 4 88 9 124 34 86 60 131 223 108 395 -18 142 -46 198 -110 225 -33
14 -172 20 -184 8z"/>
<path d="M2310 3399 c-30 -20 -37 -28 -20 -23 32 9 70 34 70 45 0 12 2 13 -50
-22z"/>
<path d="M2205 3344 l-30 -14 30 6 c17 3 34 10 40 15 14 13 -5 11 -40 -7z"/>
<path d="M1963 3293 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
<path d="M5675 8310 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M5420 8135 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M8406 5848 c-3 -13 -6 -35 -6 -51 0 -15 -9 -62 -19 -105 -10 -42 -27
-111 -36 -152 -10 -41 -20 -81 -22 -87 -4 -10 11 -13 58 -12 99 2 115 8 111
50 -2 19 -10 57 -17 84 -8 28 -22 102 -31 165 -17 120 -27 147 -38 108z"/>
<path d="M1216 5775 c10 -16 27 -40 38 -53 37 -40 220 -391 231 -442 11 -49
19 -27 16 48 -4 115 -83 247 -260 432 -33 35 -39 38 -25 15z"/>
<path d="M8691 5725 c0 -11 6 -31 14 -45 18 -32 19 -5 0 35 -10 23 -13 25 -14
10z"/>
<path d="M8780 5509 c0 -14 81 -201 92 -214 6 -6 6 2 2 20 -4 17 -10 32 -15
35 -4 3 -19 42 -34 88 -15 45 -32 82 -36 82 -5 0 -9 -5 -9 -11z"/>
<path d="M8063 4993 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M1073 4743 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M963 4733 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z"/>
<path d="M3690 2010 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2920 1914 c-8 -3 -20 -16 -27 -30 -12 -25 -11 -26 15 -21 15 3 38
-1 52 -9 24 -14 23 -14 -20 -10 -25 2 -58 8 -74 12 -25 6 -28 4 -23 -9 11 -28
-25 -38 -100 -29 -7 1 -13 12 -13 23 0 16 -3 19 -12 12 -7 -6 -40 -13 -73 -17
-101 -11 -117 -13 -200 -27 -44 -7 -82 -16 -85 -19 -9 -12 -54 -19 -65 -10 -6
5 -68 5 -152 -1 -95 -7 -168 -7 -224 -1 -90 11 -109 9 -63 -8 16 -5 38 -15 49
-22 54 -33 137 -68 181 -78 181 -42 796 47 1012 146 39 18 72 35 72 39 0 3
-13 4 -29 3 -16 -1 -27 -6 -25 -10 8 -12 -99 -6 -118 7 -10 7 -15 15 -11 18 3
4 2 7 -3 8 -57 4 -100 19 -56 19 12 0 22 5 22 10 0 10 -4 11 -30 4z m-440
-124 c0 -5 -17 -10 -37 -10 -28 0 -34 3 -23 10 20 13 60 13 60 0z m-83 -6 c-3
-3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M3216 1895 c-11 -8 -17 -17 -14 -20 2 -3 13 4 23 15 21 23 18 25 -9
5z"/>
<path d="M2860 1880 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M1991 1524 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2160 1390 c0 -13 39 -37 74 -46 25 -6 28 -5 23 10 -4 10 -7 20 -7
22 0 2 -11 4 -24 4 -14 0 -28 5 -31 10 -8 13 -35 13 -35 0z"/>
</g>
</svg>







    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
